module.exports = __webpack_public_path__ + "media/smiles/neutral_2-7f1b1598.svg";